import { recordPath, recordRoute } from '@/shared/registry'

/** Where the video service pages live. */
export const videoServicesPath = '/catalog/video-services'
export const createVideoServicePath = `${videoServicesPath}/new`
export const videoServiceRoute = recordRoute('catalog', 'video-services')
export const editVideoServiceRoute = `${videoServiceRoute}/edit`

/** A video service's details page. */
export function videoServicePath(id: string): string {
  return recordPath('catalog', 'video-services', id)
}

/** The base of Video Service Details' slots (`detailsSlots`). */
export const videoServiceDetailsSlot = 'catalog.video-service-details'

/** The API's video service endpoints. */
export const videoServicesApi = '/catalog/v1/video-services'

export function videoServiceApi(id: string): string {
  return `${videoServicesApi}/${encodeURIComponent(id)}`
}

/** The course a video is chosen for: a saved course, or, on Create Course, the organization it is for. */
export type VideoTarget = { readonly courseId: string } | { readonly organizationId: string }

function targetQuery(target: VideoTarget): URLSearchParams {
  return new URLSearchParams('courseId' in target ? { courseId: target.courseId } : { organizationId: target.organizationId })
}

/** The video services the Choose Video dialog offers for a course. */
export function videoServiceChoicesApi(target: VideoTarget): string {
  return `${videoServicesApi}/choices?${targetQuery(target).toString()}`
}

/** One page of the videos in a service that match the search. */
export function videosApi(serviceId: string, target: VideoTarget, search: string, cursor: string | null): string {
  const query = targetQuery(target)
  query.set('limit', '25')
  if (search !== '') {
    query.set('search', search)
  }
  if (cursor !== null) {
    query.set('cursor', cursor)
  }
  return `${videoServiceApi(serviceId)}/videos?${query.toString()}`
}

/** What each action needs; creating one, sending credentials or a new base URL also needs `credentials`. */
export const readVideoServicesPermission = 'catalog.video-services.read'
export const writeVideoServicesPermission = 'catalog.video-services.write'
export const deleteVideoServicesPermission = 'catalog.video-services.delete'
export const writeVideoServiceCredentialsPermission = 'catalog.video-services.credentials.write'
